export default __webpack_public_path__ + "static/media/informationIcon.f8709fee.png";